import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledTablePmePrograma } from "../../../styled-components/StyledTablePmePrograma.style";
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { MobileContext } from "../../../contexts/MobileContext";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { Multiselect } from 'multiselect-react-dropdown';
import { getEmpresas } from '../../../services/empresas';

import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import Flex from '@react-css/flex';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

export const PmeResultados = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const history = useHistory();
    const { idPrograma } = useParams(); 

    const { register, handleSubmit, reset, getValues } = useForm();
    const [isList, setIsList] = useState(true);    
    const [isLoading, setIsLoading] = useState(true);   
    
    const [programaData, setProgramaData] = useState(null);
    const [listaProgramas, setListaProgramas] = useState(null); 
    const [listaUsuariosData, setListaUsuariosData] = useState(null);
    const [multiplicadores, setMultiplicadores] = useState([]);

    const [programaDataInicio, setProgramaDataInicio] = useState(null);
    const [programaDataFim, setProgramaDataFim] = useState(null);

    const [empresaList, setEmpresaList] = useState([]);
    var [selectedEmpresa, setselectedEmpresa] = useState(null);
    var [idEmpresa, setEmpresaId] = useState(null);

    const [mesesDisponiveis, setMesesDisponiveis] = useState([]);
    const [mesSelecionado, setMesSelecionado] = useState(12);

    var [empresasUser, setEmpresasUser] = useState([]);
    var [idEmpresaIndexTab, setIdEmpresaIndexTab] = useState(0);

    const meses = [
        { nome: "JAN", numero: 0 },
        { nome: "FEV", numero: 1 },
        { nome: "MAR", numero: 2 },
        { nome: "ABR", numero: 3 },
        { nome: "MAI", numero: 4 },
        { nome: "JUN", numero: 5 },
        { nome: "JUL", numero: 6 },
        { nome: "AGO", numero: 7 },
        { nome: "SET", numero: 8 },
        { nome: "OUT", numero: 9 },
        { nome: "NOV", numero: 10 },
        { nome: "DEZ", numero: 11 }
    ];

    const handleStartDateChange = (date) => {
        setProgramaDataInicio(date);
    };

    const handleEndDateChange = (date) => {
        setProgramaDataFim(date);
    };

    const getPrograma = async(id) => {
        const response = await api.get(`PmePrograma/${id}`);
        const programa = response.data.data;
        const dataInicio = new Date(programa.dataInicio);
        const dataFinal = new Date(programa.dataFim);
        
        setProgramaDataInicio(dataInicio.toISOString().slice(0, 19).replace("T", " "));
        setProgramaDataFim(dataFinal.toISOString().slice(0, 19).replace("T", " "));         
        setProgramaData(programa);
    };

    const getListaProgramas = async(formValues) => {
        let params = '';
        let _IdEmpresa = empresasUser[0];        

        if (idEmpresaIndexTab == 1) {
            _IdEmpresa = 2
        }
        else if (idEmpresaIndexTab == 2) {
            _IdEmpresa = 0
        }

        console.log('_IdEmpresa', _IdEmpresa)

        params += `&idEmpresa=${_IdEmpresa}`;

        const response = await api.get(`PmePrograma?${params}`);
        setListaProgramas(response.data);
    };

    const getProfissionaisPrograma = async(id, dataFinalPrograma = null, empresa = 0) => {
        const dtInicio = dataFinalPrograma == '' ? null : new Date(programaDataInicio);
        const dtFinal = dataFinalPrograma == '' ? null : new Date(dataFinalPrograma);
        const response = await api.get(`PmeProfissionalPME/profissionais/programa/${id}
            ?programaDataInicio=${dtInicio.toISOString().slice(0, 19)}
            &programaDataFinal=${dtFinal.toISOString().slice(0, 19)}`);
        setListaUsuariosData(response.data);
    };    

    const calcularPorcentagemTempoXAdmissao = (idProfissional, dataAdmissao) => {
        if (!dataAdmissao) return '0.00';
        let profissional = listaUsuariosData.data.find((usuario) => usuario.idProfissional === idProfissional);
            let resultadoFinal = 1;

            if(profissional.participacaoFranquia) {
            const admissao = new Date(dataAdmissao);
            const inicioPeriodo = new Date(programaDataInicio);
            const fimPeriodo = new Date(programaDataFim);

            const diasNoMesAdmissao = new Date(admissao.getFullYear(), admissao.getUTCMonth() + 1, 0).getDate();
            const diasTrabalhadosNoMes = diasNoMesAdmissao - admissao.getDate() + 1;
            const porcentagemMesAdmissao = diasTrabalhadosNoMes / diasNoMesAdmissao;

            const mesesRestantes = Math.max(0, fimPeriodo.getMonth() - admissao.getMonth());
            const totalMesesPrograma = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const tempoTrabalhado = (porcentagemMesAdmissao + mesesRestantes) / totalMesesPrograma;
            resultadoFinal = tempoTrabalhado;            
        }
        return ((resultadoFinal) * 100);
    };

    const calcularPorcentagemProfissionalFranquia = (idProfissional, dataAdmissao, percFranquia) => {
        //Verificar se aplica ou nao
        let profissional = listaUsuariosData.data.find((usuario) => usuario.idProfissional === idProfissional);
        let resultadoFinal = 1;
        if(profissional.participacaoFranquia) {
            const admissao = new Date(dataAdmissao);
            const inicioPeriodo = new Date(programaDataInicio);
            const fimPeriodo = new Date(programaDataFim);
            inicioPeriodo.setHours(0, 0, 0, 0);
            fimPeriodo.setHours(23, 59, 59, 999);

            // console.log('admissao', admissao);
            // console.log('inicioPeriodo', inicioPeriodo);
            // console.log('fimPeriodo', fimPeriodo);

            const diasNoMesAdmissao = new Date(admissao.getFullYear(), admissao.getUTCMonth() + 1, 0).getDate();
            const diasTrabalhadosNoMes = diasNoMesAdmissao - admissao.getDate() + 1;
            const porcentagemMesAdmissao = diasTrabalhadosNoMes / diasNoMesAdmissao;
            
            const mesesRestantes = Math.max(0, fimPeriodo.getMonth() - admissao.getMonth());
            const totalMesesPrograma = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const tempoTrabalhado = (porcentagemMesAdmissao + mesesRestantes) / totalMesesPrograma;

            const mesesTrabalhados = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const resultado = (porcentagemMesAdmissao + mesesRestantes);

            //Aplicar somente se flag estiver marcada
            const peso1Mes = 0 * Math.min(1, mesesTrabalhados);
            const peso2e3Meses = 0.7 * Math.max(0, Math.min(2, mesesTrabalhados - 1)) / resultado;        
            const pesoRestante = 1 * (resultado - 3) / resultado; 

            resultadoFinal = peso1Mes + peso2e3Meses + pesoRestante;
        }
        
        
    
        return (resultadoFinal * 100);        
    };

    const calcularCalibracaoTotal = (idProfissional, dataAdmissao, percProfissional) => {
        const percentTempo = calcularPorcentagemTempoXAdmissao(idProfissional, dataAdmissao);
        const percentFranquia = calcularPorcentagemProfissionalFranquia(idProfissional, dataAdmissao, 100);
        return (((percentTempo * percentFranquia) / 100) / 100);
    };

    const calcularGatilho = (calibTotal, gatilho) => {
        const result = calibTotal * gatilho;
        return result;
    };

    const calcularYTD = (gatilho) => {
        const date = new Date();
        const result = (gatilho / (mesSelecionado + 1)) * date.getUTCMonth();
        return result;
    };

    const calcularYTDPerc = (hfi, proporcional) => {
        const result = (hfi / proporcional) * 100;
        return result;
    };

    const calcularHFMu = (dados) => {
        if (!dados || !Array.isArray(dados) || dados.length === 0) return {};
    
        const resultadosPorArea = {};
        //console.log(dados);
    
        dados.forEach((item) => {
            const { idArea, horaFaturada, idProfissional, dataAdmissao, percProfissional } = item;
            const calibracao = calcularCalibracaoTotal(idProfissional, dataAdmissao, percProfissional);
    
            if (!resultadosPorArea[idArea]) {
                resultadosPorArea[idArea] = {
                    somaProduto: 0,
                    somaCalibracao: 0,
                };
            }
    
            // Atualizar somaProduto e somaCalibracao
            const hora = parseFloat(horaFaturada) || 0;
            resultadosPorArea[idArea].somaProduto += hora * calibracao;
            resultadosPorArea[idArea].somaCalibracao += calibracao;
        });
    
        const resultadosFinais = {};
        Object.keys(resultadosPorArea).forEach((idArea) => {
            const { somaProduto, somaCalibracao } = resultadosPorArea[idArea];
            resultadosFinais[idArea] = (somaCalibracao > 0 ? (somaProduto / somaCalibracao).toFixed(2) : 0);
        });
    
        return resultadosFinais ;
    };       

    const calcularHFMg = (dados, calibracaoTotal) => {
        if (!dados || !Array.isArray(dados) || dados.length === 0) return 0;
    
        const somaProduto = dados.reduce((soma, item) => {

            const horaFaturada = parseFloat(item.horaFaturada) || 0;
            const calibracao = parseFloat(calcularCalibracaoTotal(item.idProfissional, item.dataAdmissao, item.percProfissional)) || 0;
            return soma + horaFaturada * calibracao;
        }, 0);
    
        const somaCalibracao = dados.reduce((soma, item) => {
            const calibracao = parseFloat(calcularCalibracaoTotal(item.idProfissional, item.dataAdmissao, item.percProfissional)) || 0;
            return soma + calibracao;
        }, 0);
    
        let tot = somaCalibracao > 0 ? (somaProduto / somaCalibracao).toFixed(2) : 0;

        return somaCalibracao > 0 ? (somaProduto / somaCalibracao).toFixed(2) : 0;
    };

    const calculaHFIc = (calibracaoFranqProf, calibracaoTempo, horaFaturada) => {
        const fator = (1 + (1 - (calibracaoFranqProf / 100))) / calibracaoTempo;
        const hfic = fator * horaFaturada;

        return hfic;
    };    

    const getacoes = (idPrograma) => {
        return (
            <div className="text-center">
                <span className="cursor-pointer color-icon-default m-1" onClick={() => setRedirectFormEdit(idPrograma)} title="Editar este programa">
                    <i className="fa fa-eye" aria-hidden="true"></i>
                </span>
            </div>
        );
    };

    const voltar = async () => {
        setIsList(true)
        history.push(`/pme-resultados/`)
    }

    const setRedirectFormEdit = (idPrograma) => {
        history.push(`/pme-resultados/programa/${idPrograma}`);
    }

    const getEmpresa = async (currentValue, value) => {
        if (value === "clear" || value === null) {
            setselectedEmpresa(null);
            setEmpresaId(null);
            await getProfissionaisPrograma(idPrograma, null, 0);
            return;
        }

        var statusResult = empresaList.filter(function (o) {
            return o.idEmpresa == value;
        });

        var status = statusResult[0].description;
        var idStatus = statusResult[0].idEmpresa;
        setselectedEmpresa(status);
        setEmpresaId(idStatus);

        await getProfissionaisPrograma(idPrograma, null, idStatus);
    };

    const handleSetEmpresa = async (empresa) => {
        try {
            setIsLoading(true);
            if (idPrograma) { 
                await getProfissionaisPrograma(idPrograma, null, empresa);
            }
        } catch (err) {
            console.error("Erro na inicialização:", err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSetDataFim = async (mes) => {
        try {
            setIsLoading(true);
            const dataAtualizada = new Date();
            dataAtualizada.setMonth(mes, 0);
            dataAtualizada.setHours(0, 0, 0, 0);

            setProgramaDataFim(dataAtualizada);
            setMesSelecionado(mes - 1);

            if (idPrograma) { 
                await getProfissionaisPrograma(idPrograma, dataAtualizada, 0);
            }
        } catch (err) {
            console.error("Erro na inicialização:", err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const calculoMeritos = (hfmic, hmfu, hmfg, area) => {
        
        let calcMerito = 0;
        if(area == "Designers") {
            calcMerito = (0.60 * hfmic) + (0.40 * hmfg);
        } else {
            calcMerito = (0.60 * hfmic) + (0.30 * hmfu) + (0.10 * hmfg);
        }
        // e
        return calcMerito;
    };

    const getMultiplicadores = async () => {
        try {
            const response = await api.get(`TabelaMultiplicadores/multiplicador/1/${idPrograma}`);
            //console.log('multiplicadores', response.data.data);
            setMultiplicadores(response.data.data);
        } catch (err) {
            console.error("Erro ao buscar multiplicadores:", err.message);
        }
    };

    const getMultiplicador = (merito, multiplicadores) => {
        // console.log('merito', merito);
        // console.log('multiplicadores', multiplicadores);
        if (!multiplicadores || multiplicadores.length === 0) {
            return 0; // Retorna 0 se não houver multiplicadores
        }
    
        // Filtrar os multiplicadores que atendem à condição
        const multiplicadorEncontrado = multiplicadores.find(multi => 
            merito >= multi.de && merito <= multi.ate
        );
    
        return multiplicadorEncontrado ? multiplicadorEncontrado.multiplicador : 0;
    };

    const getMultiplicadorTempo = (calibracaoTotal, multiplicador) => {
        //console.log('calibracaoTotal', calibracaoTotal);
        //console.log('multiplicador', multiplicador);
        //console.log('calculo', (multiplicador * calibracaoTotal));
        return multiplicador * calibracaoTotal;
    }

    const temMaisDeTresAnos = (dataAdmissao, dataInicioPrograma) => {
        if (!dataAdmissao || !dataInicioPrograma) return false;
    
        const admissao = new Date(dataAdmissao);
        const inicioPrograma = new Date(dataInicioPrograma);
    
        if (admissao >= inicioPrograma) {
            return false;
        }
    
        const diferencaAnos = inicioPrograma.getFullYear() - admissao.getFullYear();
        const ajusteMes = inicioPrograma.getMonth() - admissao.getMonth();
        const ajusteDia = inicioPrograma.getDate() - admissao.getDate();
    
        if (ajusteMes < 0 || (ajusteMes === 0 && ajusteDia < 0)) {
            return diferencaAnos - 1 >= 3;
        }
    
        return diferencaAnos >= 3;
    };

    const filtroEmpresa = async (currentValue, indexTab) => {
        idEmpresaIndexTab = indexTab;
        setIdEmpresaIndexTab(idEmpresaIndexTab);

        const valuesForm =  getValues();
        let formValues = {
            empresa: currentValue
        };

        const result = await getListaProgramas(formValues);
        setProgramaData(result);
        console.log('result', result)
    }     

    const checkIsMultEmpresaUser = (value) => {
        const empresas = localStorage.getItem('empresasUsuario') ?
            JSON.parse(localStorage.getItem('empresasUsuario'))
            : [];

        if (empresas) {
            empresasUser = empresas;
            setEmpresasUser(empresasUser);
        }

        if (empresasUser.length > 1) {
            idEmpresaIndexTab = 0;
            setIdEmpresaIndexTab(idEmpresaIndexTab);
        } else {
            switch (empresasUser[0]) {
                case '1':
                case 1:
                    setIdEmpresaIndexTab(0);
                    break;
                case '2':
                case 2:
                    setIdEmpresaIndexTab(1);
                    break;
                default:
                    setIdEmpresaIndexTab(2);
                    break;

            }
        }


    }

    // useEffect(() => {
    //     const asyncFn = async () => {
    //         await getListaProgramas();        
        
    //     }
    //     asyncFn();
    //     checkIsMultEmpresaUser();
    // }, [null, 0, 10]);

    useEffect(() => {
        console.log(idPrograma);
        console.log(programaDataInicio);
        const asyncFn = async () => {
            try {
                setIsLoading(true);
                if (idPrograma) {
                    setIsList(false);
                    await getPrograma(idPrograma);              
                    await getProfissionaisPrograma(idPrograma, null, 0); 
                    await getMultiplicadores();
                    
                    const hoje = new Date();
                    const mesCorrente = hoje.getMonth();
                    const mesInicio = programaDataInicio ? new Date(programaDataInicio).getMonth() : 0;

                    const mesesFiltrados = meses.filter(mes => mes.numero <= mesCorrente && mes.numero >= mesInicio);
                    setMesesDisponiveis(mesesFiltrados);

                    const empresas = localStorage.getItem('empresasUsuario') ?
                        JSON.parse(localStorage.getItem('empresasUsuario'))
                            : [];
        
                    const empresaList = await getEmpresas();
                    if (!!empresaList) {
                        setEmpresaList(empresaList.filter(empresa => empresas.indexOf(empresa.idEmpresa) > -1))
                    }

                    console.log(empresaList);
                } else {
                    checkIsMultEmpresaUser();
                    await getListaProgramas();
                }
                
            } catch (err) {
                console.error("Erro na inicialização:", err.message);
            } finally {
                setIsLoading(false);
            }           
        }
        asyncFn()
    }, [idPrograma, programaDataInicio]);   

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">PME - Resultados </h5>
                        </div>
                        { !isList ? <input type="button" className='default-button ml-3' value='Voltar' onClick={voltar} /> : ''}
                    </div>
                    { !isList ?
                        <div className="card">
                            <div className="row justify-content-left mb-2">
                                <div className="col-sm-12 col-md-10 col-lg-10 col-xxl-10">
                                {mesesDisponiveis.map((mes) => (
                                    <input
                                        key={mes.nome}
                                        type="button"
                                        className={mesSelecionado > (mes.numero) ? "default-button me-1" : "default-button-red me-1"}
                                        value={mes.nome}
                                        onClick={() => handleSetDataFim(mes.numero + 1)}
                                        style={{ minWidth: '100px', height: '45px' }}
                                    />
                                ))}
                                </div>
                            </div>
                            <StldRow>
                                <Flex>
                                    <StyledForm style={{ width: "100%" }}>
                                    {
                                        isLoading ?
                                        <StldRow>
                                            <div className="text-center">
                                                <div className="d-flex align-items-center">
                                                    <strong style={{ color: "#EE4B21" }}>Carregando...</strong>
                                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                </div>
                                            </div>
                                        </StldRow>
                                        :
                                        <StyledTablePmePrograma>
                                            <StyledTablePage>
                                                {
                                                    listaUsuariosData?.data?.length > 0 ?
                                                    (
                                                        <div className="table-scroll font-0-9x table-bordered table-container" style={{borderLeft: "none", borderRight: "none", borderBottom: "none"}}>
                                                            <table className="table table-width table-sm">
                                                                <thead>
                                                                    <tr className="text-center" style={{backgroundColor: "#2c3b82", color: "#FFFFFF"}}>
                                                                        <td colSpan={2}>Informações Gerais</td>
                                                                        <td colSpan={3}>Horas Faturadas</td>
                                                                        <td colSpan={4}>Calibrações</td>
                                                                        <td colSpan={6}>Acompanhamento / Elegibilidade Individual</td>
                                                                        <td colSpan={4}>Méritos</td>
                                                                    </tr>
                                                                    <tr className="table-legend-info">
                                                                        <th key="nomeUsuario">Profissional</th>
                                                                        <th key="nomeArea">Área</th>

                                                                        <th key="HFi">HFi</th>
                                                                        <th key="HMFu">HMFu</th>
                                                                        <th key="HMFg">HMFg</th>

                                                                        <th key="percProfissionalCalibTotal">% Calib. Total</th>
                                                                        <th key="gatilho">Gatilho</th>
                                                                        <th key="meta">Meta</th>
                                                                        <th key="superMeta">Super Meta</th>

                                                                        <th key="metaYTDGatilho">Gatilho<br />YTD</th>
                                                                        <th key="metaYTD">Meta<br />YTD</th>
                                                                        <th key="metaYTDSuper">Super Meta<br />YTD</th>
                                                                        <th key="metaYTDPercGatilho">Gatilho<br />YTD</th>
                                                                        <th key="metaYTDPerc">Meta<br />YTD</th>
                                                                        <th key="metaYTDPercSuper">Super Meta<br />YTD</th>

                                                                        <th key="metaHFIc">HFIc</th>
                                                                        <th key="metaMeritos">Méritos<br/>(MP, MD, MC e MG)</th>
                                                                        <th key="metaMultiplicadores">Multiplicador</th>
                                                                        <th key="metaMultiplicadoresProporc">Multiplicador <br/>Proporcional (% Tempo)</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        listaUsuariosData?.data?.map((usuario, index) => {
                                                                            const calibracaoTotal = calcularCalibracaoTotal(
                                                                                usuario.idProfissional,
                                                                                usuario.dataAdmissao,
                                                                                usuario.percProfissional
                                                                            );

                                                                            const horaFaturadaIndividual = calcularGatilho(
                                                                                calibracaoTotal,
                                                                                programaData.gatilhos[0].horaFaturadaIndividual
                                                                            );

                                                                            const hmfIndividual = calcularGatilho(
                                                                                calibracaoTotal,
                                                                                programaData.metas[0].hmfIndividual
                                                                            );

                                                                            const superHMFIndividual = calcularGatilho(
                                                                                calibracaoTotal,
                                                                                programaData.metas[0].superHMFIndividual
                                                                            );

                                                                            const hfmu = calcularHFMu(listaUsuariosData.data)[usuario.idArea];
                                                                            const hfmg = calcularHFMg(listaUsuariosData.data, calibracaoTotal);
                                                                            const hfmic = calculaHFIc(usuario.calibracaoPercProfissionalFranquia, calibracaoTotal, usuario.horaFaturada);

                                                                            const meritos = calculoMeritos(hfmic, hfmu, hfmg, usuario.nomeArea);

                                                                            const multiplicador = getMultiplicador(meritos, multiplicadores);

                                                                            const multiplicadorTempo = getMultiplicadorTempo(calibracaoTotal, multiplicador);

                                                                            const maisDeTresAnos = temMaisDeTresAnos(usuario.dataAdmissao, programaData.dataInicio);

                                                                            return (
                                                                                <tr key={`row-profissional-${usuario.idProfissional}`} style={{fontSize: '13px'}}>
                                                                                    {/* <td className="text-center">{ getacoes(usuario.idProfissional) }</td> */}
                                                                                    <td className="">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            { usuario.nome }
                                                                                            {
                                                                                                maisDeTresAnos ? ('') : 
                                                                                                (<span className="badge bg-warning">R</span>)
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="text-center">{ usuario.nomeArea }</td>
                                                                                    
                                                                                    <td className="text-center">{ usuario.horaFaturada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>                                                                                    
                                                                                    <td className="text-center">{ usuario.nomeArea == 'Designer' ? '-' : hfmu }</td>
                                                                                    <td className="text-center">{ hfmg }</td>

                                                                                    <td className="text-center">{ (calibracaoTotal * 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ horaFaturadaIndividual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ hmfIndividual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ superHMFIndividual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>

                                                                                    <td className="text-center">{ calcularYTD(horaFaturadaIndividual).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ calcularYTD(hmfIndividual).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ calcularYTD(superHMFIndividual).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-left">                                                                                        
                                                                                        { 
                                                                                            (() => {
                                                                                                const perc = calcularYTDPerc(usuario.horaFaturada, calcularYTD(horaFaturadaIndividual)).toFixed(0);
                                                                                        
                                                                                                if (perc >= 100) {
                                                                                                    return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                                } else if (perc >= 75 && perc < 100) {
                                                                                                    return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else if (perc >= 50 && perc < 75) {
                                                                                                    return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else {
                                                                                                    return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                                }
                                                                                            })()
                                                                                        }
                                                                                        { calcularYTDPerc(usuario.horaFaturada, calcularYTD(horaFaturadaIndividual)).toFixed(2) }%
                                                                                    </td>
                                                                                    <td className="text-left">                                                                                        
                                                                                        { 
                                                                                            (() => {
                                                                                                const perc = calcularYTDPerc(usuario.horaFaturada, calcularYTD(hmfIndividual)).toFixed(0);
                                                                                        
                                                                                                if (perc >= 100) {
                                                                                                    return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                                } else if (perc >= 75 && perc < 100) {
                                                                                                    return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else if (perc >= 50 && perc < 75) {
                                                                                                    return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else {
                                                                                                    return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                                }
                                                                                            })()
                                                                                        }
                                                                                        { calcularYTDPerc(usuario.horaFaturada, calcularYTD(hmfIndividual)).toFixed(2) }%
                                                                                    </td>
                                                                                    <td className="text-left">                                                                                        
                                                                                        { 
                                                                                            (() => {
                                                                                                const perc = calcularYTDPerc(usuario.horaFaturada, calcularYTD(superHMFIndividual)).toFixed(0);
                                                                                        
                                                                                                if (perc >= 100) {
                                                                                                    return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                                } else if (perc >= 75 && perc < 100) {
                                                                                                    return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else if (perc >= 50 && perc < 75) {
                                                                                                    return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else {
                                                                                                    return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                                }
                                                                                            })()
                                                                                        }
                                                                                        { calcularYTDPerc(usuario.horaFaturada, calcularYTD(superHMFIndividual)).toFixed(2) }%
                                                                                    </td>
                                                                                    <td className="text-center">{ hfmic.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ meritos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ multiplicador.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ multiplicadorTempo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>

                                                                                    {/* <td className="text-center">
                                                                                        {
                                                                                            usuario.participacaoCalculo == 1 
                                                                                            ? 'Sim'
                                                                                            : 'Não'
                                                                                        }
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        {
                                                                                            usuario.status == 1 
                                                                                            ? <i className="fa fa-circle text-success" aria-hidden="true"></i>
                                                                                            : <i className="fa fa-circle text-danger" aria-hidden="true"></i>
                                                                                        }
                                                                                    </td> */}
                                                                                </tr>
                                                                            )})
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : listaUsuariosData?.data && listaUsuariosData.data?.length === 0 ? (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    ) : (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Erro ao carregar os dados ou estrutura inesperada.
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                            </StyledTablePage>
                                        </StyledTablePmePrograma>
                                    }
                                    </StyledForm>
                                </Flex>
                            </StldRow>
                        </div>
                    :
                        <div className="card">
                            <StldRow>
                                <Flex>
                                    <StyledForm style={{ width: "100%" }}>
                                        {
                                        isLoading ? 
                                            <StldRow>
                                                <div className="text-center">
                                                    <div className="d-flex align-items-center">
                                                        <strong style={{ color: "#EE4B21" }}>Carregando...</strong>
                                                        <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                    </div>
                                                </div>
                                            </StldRow> 
                                        : 
                                            (
                                            <Tabs className="timesheet m-0" selectedIndex={idEmpresaIndexTab}>
                                                {empresasUser?.length > 1 ? <TabList>
                                                    <Tab onClick={() => filtroEmpresa(1, 0)}>Critério Experts</Tab>
                                                    <Tab onClick={() => filtroEmpresa(2, 1)}>Adjusters</Tab>
                                                    <Tab onClick={() => filtroEmpresa(-1, 2)}>Todos</Tab>
                                                </TabList> : ''}
                                                <TabPanel>
                                                    <StyledTablePmePrograma>
                                                            <StldRow>
                                                                <div className="text-center mb-2">
                                                                    <div className="d-flex align-items-center">
                                                                        Selecione um Programa para ver o resultado dos Participantes
                                                                    </div>
                                                                </div>
                                                            </StldRow> 
                                                            <StyledTablePage>
                                                            {
                                                                listaProgramas?.data?.length > 0 ? 
                                                                (
                                                                    <div className="table-scroll font-0-9x table-bordered table-container">
                                                                        <table className="table table-width" style={{ width: "100%" }}>
                                                                            <thead>
                                                                                <tr className="table-legend-info">
                                                                                    <th key="ac">Ações</th>
                                                                                    <th key="nomePrograma">Nome do Programa</th>
                                                                                    <th key="inicio_termino" colSpan={2}>Vigência</th>                                                                            
                                                                                    <th key="contemplados">Contemplados</th>
                                                                                    {/* <th key="status">Status</th> */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {listaProgramas.data
                                                                                .sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio)) // Ordena do mais recente para o mais antigo
                                                                                .map((programa, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                                        <td className="text-center">{ programa.nomePrograma }</td>
                                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                                        <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                                        {/* <td className="text-center">                                                                                   
                                                                                            {
                                                                                                programa.status == 1 
                                                                                                ? <i className="fa fa-circle text-success" aria-hidden="true"></i>
                                                                                                : <i className="fa fa-circle text-danger" aria-hidden="true"></i>
                                                                                            }                                                                                    
                                                                                        </td> */}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ) : listaProgramas?.data && listaProgramas.data.length === 0 ? (
                                                                    <StldColumn xs="12" sm="12" md="12">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            Atenção! Nenhum resultado encontrado!
                                                                        </div>
                                                                    </StldColumn>
                                                                ) : (
                                                                    <StldColumn xs="12" sm="12" md="12">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            Erro ao carregar os dados ou estrutura inesperada.
                                                                        </div>
                                                                    </StldColumn>
                                                                )
                                                            }
                                                        </StyledTablePage>
                                                    </StyledTablePmePrograma>
                                                </TabPanel>
                                                <TabPanel>
                                                    <StyledTablePmePrograma>
                                                            <StldRow>
                                                                <div className="text-center mb-2">
                                                                    <div className="d-flex align-items-center">
                                                                        Selecione um Programa para ver o resultado dos Participantes
                                                                    </div>
                                                                </div>
                                                            </StldRow> 
                                                            <StyledTablePage>
                                                            {
                                                                listaProgramas?.data?.length > 0 ? 
                                                                (
                                                                    <div className="table-scroll font-0-9x table-bordered table-container">
                                                                        <table className="table table-width" style={{ width: "100%" }}>
                                                                            <thead>
                                                                                <tr className="table-legend-info">
                                                                                    <th key="ac">Ações</th>
                                                                                    <th key="nomePrograma">Nome do Programa</th>
                                                                                    <th key="inicio_termino" colSpan={2}>Vigência</th>                                                                            
                                                                                    <th key="contemplados">Contemplados</th>
                                                                                    {/* <th key="status">Status</th> */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {listaProgramas.data
                                                                                .sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio)) // Ordena do mais recente para o mais antigo
                                                                                .map((programa, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                                        <td className="text-center">{ programa.nomePrograma }</td>
                                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                                        <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                                        {/* <td className="text-center">                                                                                   
                                                                                            {
                                                                                                programa.status == 1 
                                                                                                ? <i className="fa fa-circle text-success" aria-hidden="true"></i>
                                                                                                : <i className="fa fa-circle text-danger" aria-hidden="true"></i>
                                                                                            }                                                                                    
                                                                                        </td> */}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ) : listaProgramas?.data && listaProgramas.data.length === 0 ? (
                                                                    <StldColumn xs="12" sm="12" md="12">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            Atenção! Nenhum resultado encontrado!
                                                                        </div>
                                                                    </StldColumn>
                                                                ) : (
                                                                    <StldColumn xs="12" sm="12" md="12">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            Erro ao carregar os dados ou estrutura inesperada.
                                                                        </div>
                                                                    </StldColumn>
                                                                )
                                                            }
                                                        </StyledTablePage>
                                                    </StyledTablePmePrograma>
                                                </TabPanel>
                                                <TabPanel>
                                                    <StyledTablePmePrograma>
                                                            <StldRow>
                                                                <div className="text-center mb-2">
                                                                    <div className="d-flex align-items-center">
                                                                        Selecione um Programa para ver o resultado dos Participantes
                                                                    </div>
                                                                </div>
                                                            </StldRow> 
                                                            <StyledTablePage>
                                                            {
                                                                listaProgramas?.data?.length > 0 ? 
                                                                (
                                                                    <div className="table-scroll font-0-9x table-bordered table-container">
                                                                        <table className="table table-width" style={{ width: "100%" }}>
                                                                            <thead>
                                                                                <tr className="table-legend-info">
                                                                                    <th key="ac">Ações</th>
                                                                                    <th key="nomePrograma">Nome do Programa</th>
                                                                                    <th key="inicio_termino" colSpan={2}>Vigência</th>                                                                            
                                                                                    <th key="contemplados">Contemplados</th>
                                                                                    {/* <th key="status">Status</th> */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {listaProgramas.data
                                                                                .sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio)) // Ordena do mais recente para o mais antigo
                                                                                .map((programa, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                                        <td className="text-center">{ programa.nomePrograma }</td>
                                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                                        <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                                        {/* <td className="text-center">                                                                                   
                                                                                            {
                                                                                                programa.status == 1 
                                                                                                ? <i className="fa fa-circle text-success" aria-hidden="true"></i>
                                                                                                : <i className="fa fa-circle text-danger" aria-hidden="true"></i>
                                                                                            }                                                                                    
                                                                                        </td> */}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ) : listaProgramas?.data && listaProgramas.data.length === 0 ? (
                                                                    <StldColumn xs="12" sm="12" md="12">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            Atenção! Nenhum resultado encontrado!
                                                                        </div>
                                                                    </StldColumn>
                                                                ) : (
                                                                    <StldColumn xs="12" sm="12" md="12">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            Erro ao carregar os dados ou estrutura inesperada.
                                                                        </div>
                                                                    </StldColumn>
                                                                )
                                                            }
                                                        </StyledTablePage>
                                                    </StyledTablePmePrograma>
                                                </TabPanel>
                                            </Tabs>
                                            )
                                        }
                                    </StyledForm>
                                </Flex>
                            </StldRow>
                        </div>
                    }
                </StyledDefaultPage>
                </main>
        </section >
    );
};

export const ResultadosPmePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <PmeResultados />
                </>
            )}
        </>
    );
};